import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clemos-lead-tasks',
  templateUrl: './lead-tasks.component.html',
  styleUrls: ['./lead-tasks.component.scss']
})
export class LeadTasksComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
